<template>
  <div>
    <el-row style="margin-bottom:20px">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/director-workmaster' }">工作通</el-breadcrumb-item>
        <el-breadcrumb-item>帮忙</el-breadcrumb-item>
      </el-breadcrumb>
    </el-row>
    <div class="top">
      <div>
        <img src="@/assets/community/back.png" alt="" class="top-left-img" @click="back" />
      </div>

      <div>
        <img src="@/assets/work/wodebangzhu.png" alt="" class="top-midlle-img" />
      </div>
      <div class="top-midlle-span">发布帮忙</div>
    </div>
    <div class="middle">
      <div style="height: 10px"></div>
     
      <div>
        <el-steps :active="active" align-center process-status="wait" finish-status="success">
          <el-step title="基本信息"></el-step>
          <el-step title="对投标人的要求"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <div style="height: 50px"></div>
      <div class="release-message" v-show="color_status == 1">
        <el-form ref="form1" :model="form1" :rules="rules1" label-width="80px">

          <el-form-item label="选择项目" prop="project_id">
                <el-select
                    v-model="form1.project_id" placeholder="全部"
                      clearable
                      filterable
                      value-key="id"
                    >
                    <el-option
                      v-for="item2 in projectList"
                      :key="item2.project_id"
                      :label="item2.name"
                      :value="item2.project_id"
                    />
                </el-select>
         </el-form-item>


          <el-form-item label="帮忙标题" prop="title">
            <el-input v-model="form1.title"></el-input>
          </el-form-item>
          <el-form-item label="帮忙简介" prop="sketch">
            <el-input type="textarea" v-model="form1.sketch"></el-input>
          </el-form-item>

        
          <el-row>
            <el-col :span="24" style="text-align:right;margin-bottom: 10px;cursor: pointer;">            
              <el-tag @click="addComponents">添加明细</el-tag>
          </el-col>
          </el-row>
          <el-row style="background-color:#f1f2f2;text-align: center;padding: 10px 0px;">
        
            <el-col :span="8">标题</el-col>
            <el-col :span="8">金额</el-col>
            <el-col :span="8">操作</el-col>
          </el-row>
          <el-row  v-for="(item, index) in form1.peoples" :key="index" style="text-align: center;padding: 10px 0px;">
            <el-col :span="8">
                <el-form-item label="标题" :prop="'peoples.' + index + '.commission'"  :rules="rules1.peoples_commission">
                    <el-input v-model="item.commission"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="金额" :prop="'peoples.' + index + '.people'"  :rules="rules1.peoples_people">
                    <el-input v-model="item.people"></el-input>
                </el-form-item>
            </el-col>
            <el-col :span="8" >
              <el-button @click.prevent="removeComp(index)" v-if="index>0">删除</el-button>
            </el-col>
        </el-row>

       <el-row>
          <el-col :span="12">
              <el-form-item label="员工工资" prop="wages">
                <el-input v-model="form1.wages" style="width: 220px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="佣金" prop="commission">
                <el-input v-model="form1.commission" style="width: 220px"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="佣金方式" prop="com_type">
                <el-select v-model="form1.com_type">
                  <el-option v-for="i in com_type_list" :key="i.value" :label="i.label" :value="i.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          
           
            <el-col :span="12">
              <el-form-item label="佣金结算方式" prop="com_settle_type">
                <el-select v-model="form1.com_settle_type">
                  <el-option v-for="i in com_settle_list" :key="i.value" :label="i.label" :value="i.value"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>   
            <el-col :span="12">
              <el-form-item label="起始时间" prop="start_at">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form1.start_at"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结束时间" prop="end_at">
                <el-date-picker type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="form1.end_at"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="帮忙描述" prop="description">
            <el-input type="textarea" v-model="form1.description"></el-input>
          </el-form-item>
          <div style="height: 80px"></div>
          <el-form-item>
            <el-button style="float: right" type="primary" @click="nextStep">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="release-require" v-show="color_status == 0">
        <el-form ref="form2" :model="form2" :rules="rules2" label-width="130px">
          <el-form-item label="允许投标名额" prop="bid_number">
            <el-input v-model="form2.bid_number"></el-input>
          </el-form-item>
          <el-form-item label="投标人所在区域" prop="region">
            <el-input v-model="form2.region"></el-input>
          </el-form-item>

          <el-form-item label="投标人类型" prop="bid_type">
            <el-checkbox-group v-model="form2.bid_type">
              <el-checkbox v-for="i in bid_type_list" :key="i.value" :label="i.value">{{ i.label }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="联系人" prop="bid_type">
            <el-input v-model="form2.contacts"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="bid_type">
            <el-input v-model="form2.mobile"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="bid_type">
            <el-input v-model="form2.email"></el-input>
          </el-form-item>
          <el-form-item label="多人中标" prop="bid_type">
            <el-select v-model="form2.many_bid" placeholder="" style="width: 710px">
              <el-option label="允许" value="1"></el-option>
              <el-option label="不允许" value="2"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上传附件" prop="annex_url">
            <el-upload class="upload-demo" drag :action="uploadFileUrl" :file-list="fileList" :limit="1" :on-error="handleUploadError" :on-exceed="handleExceed" :on-success="handleUploadSuccess">
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                <em>点击上传</em>
                <!-- <div class="el-upload__tip" slot="tip">
                  只能上传jpg/png文件，且不超过500kb
                </div> -->
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button style="float: right" type="primary" @click="onSubmit">提 &nbsp; 交</el-button>
            <el-button style="float: right; margin-right: 20px" type="primary" @click="preStep">上一步</el-button>
          </el-form-item>
        </el-form>
      </div>

    </div>

  </div>

</template>

<script>
import { webCrowdAdd,webRecruitProjectList } from "@/api/director/package/index";
import urlConfig from '@/api/config'
export default {
  data () {
    return {
      uploadFileUrl: urlConfig.prod.baseURL + "/web/file/Upload", // 上传的图片服务器地址
      projectList:[],
      fileList: [],
      color_status: 1,
      active:1,
      form1: {
        project_id:"",
        mode: "2",
        title: "",
        sketch: "",
        wages: "",
        commission: "",
        com_type: "",
        com_settle_type: "",
        description: "",
        start_at: "",
        end_at: "",
        peoples:[{
          commission:"",
          people:"",
        }]
      },
      form2: {
        bid_number: "",
        region: "",
        bid_type: [],
        contacts: '',
        mobile: "",
        email: "",
        many_bid: "",
        annex_name: "",
        annex_url: "",
        peoples: "",
      },
      rules1: {
        project_id: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        sketch: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        wages: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        commission: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        com_type: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        com_settle_type: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        description: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        start_at: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        end_at: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        peoples_commission: [
              {required: true, message: '必选项', trigger: 'change'}
          ],
          peoples_people: [
              {required: true, message: '必选项', trigger: 'blur'}
          ],

      },
      rules2: {
        bid_number: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        bid_type: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        contacts: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
        many_bid: [
          { required: true, message: '必选项', trigger: 'change' }
        ],
        annex_url: [
          { required: true, message: '必填项', trigger: 'blur' },
        ],
      },
      com_type_list: [
        {
          value: '1',
          label: '按人'
        },
        {
          value: '2',
          label: '按件'
        },
        {
          value: '3',
          label: '总价'
        },
      ],
      com_settle_list: [
        {
          value: '1',
          label: '日结'
        },
        {
          value: '2',
          label: '周结'
        },
        {
          value: '3',
          label: '月结'
        },
        {
          value: '4',
          label: '完工结'
        },
        {
          value: '5',
          label: '入职结'
        },
      ],
      bid_type_list: [
        {
          value: '1',
          label: '个人'
        },
        {
          value: '2',
          label: '社团'
        },
        {
          value: '3',
          label: '企业'
        },
      ],
    };
  },
  mounted () {
   
    this.initProject();
  },
  methods: {

    removeComp(index){
        if (index !== -1) {
          this.form1.peoples.splice(index, 1)
        }
      },

      addComponents(){
        this.form1.peoples.push({
                people: null,
                commission: null,
        })

      },

    nextStep () {
      this.$refs.form1.validate((valid) => {
        if (valid) {
          console.log(this.form1);
          this.color_status = 0;
          this.active++;
        } else {
          return false;
        }
      });
    },
    preStep () {
      this.color_status = 1;
      this.active--
    },
    onSubmit () {
      this.$refs.form2.validate((valid) => {
        if (valid) {
          this.form2 = { ...this.form2, ...this.form1, }

          webCrowdAdd(this.form2).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({
                message: res.msg,
                type: 'success',
                duration: 2000,
                onClose: () => {
                  this.$router.push({ name: "help-mine-records", query: { corpor_id:  this.form2.corpor_id } });
                }
              });
            } else {
              this.$message.error(res.msg ? res.msg : "请求错误");
            }
          });

        } else {

          return false;
        }
      });
    },

    initProject(){
      webRecruitProjectList({}).then((res) => {
            console.log(res);
            if (res.code == 200) {
             this.projectList=res.data;
            } else {
              this.$message.error(res.msg ? res.msg : "请求错误");
            }
          });
    },
    back () {
      this.$router.go(-1);
    },

    removeFile () {
      this.fileList = [];
      this.form2.annex_url = '';
      this.form2.annex_name = '';
    },


    // 文件个数超出
    handleExceed () {
      this.$message.error(`只允许上传单个文件`);
    },
    // 上传失败
    handleUploadError (err) {
      this.$message.error("上传失败, 请重试");
    },
    // 上传成功回调
    handleUploadSuccess (res, file) {
      console.log(res);
      this.form2.annex_url = res.file;
      this.form2.annex_name = res.filename;
      this.$message.success("上传成功");
      console.log(this.form2);

    },

    // 获取文件名称
    getFileName (name) {
      if (name.lastIndexOf("/") > -1) {
        return name.slice(name.lastIndexOf("/") + 1).toLowerCase();
      } else {
        return "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.essential_information {
  color: #acacac;
}
.essential_information1 {
  color: #4d71d9;
}

.circle {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 20px;
  width: 20px;
  border-style: solid;
  border-radius: 25px;
}
.release-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.last_step {
  margin-left: 760px;
}
.last_step2 {
  margin-left: 650px;
  margin-top: -50px;
}
.tender-time {
  // display: flex;
}
.top {
  width: 950px;
  height: 31px;
  display: flex;
}
.top-left-img {
  margin-top: 8px;
  width: 25px;
  height: 25px;
}
.top-midlle-img {
  width: 40px;
  height: 40px;
}
.top-midlle-span {
  margin-left: 20px;
  margin-top: 8px;
  height: 16px;
  font-size: 16px;
  color: #181818;
  font-weight: bold;
}
.top-right {
  margin-top: 2px;
  margin-left: 740px;
}

.middle {
  width: 840px;

  margin-top: 40px;
  flex-direction: column;
}
</style>
